import { Component, Input } from '@angular/core';
import { ComponentStateService } from 'app/core/services';
import { map, Observable, startWith } from 'rxjs';
import { PageHeaderState } from './page-header.component';

@Component({
  selector: 'insol-page-box',
  template: `<div
    style="height: calc(100vh - {{ currentHeight$ | async }}px)"
    class="
  flex flex-col flex-auto mb-6 overflow-x-auto {{
      margin ? 'my-8 mx-6' : ''
    }} py-6 px-3 md:px-5 shadow print:shadow-none rounded-2xl bg-card dark:bg-transparent">
    <ng-content></ng-content>
  </div>`,
})
export class PageBoxComponent {
  /** Whether to include margins on the page box.  Use margin=true if the outer container does not have padding. */
  @Input() margin: boolean;

  /** Height of all page elements above the insol-page-box.  Used to calculate height of the box,
   * so it shows fully on the screen without scrolling.  Make it ~100px to allow scrolling enough to hide the header elements.
   * Defaults to 315, the height of header on time review pages */
  @Input() headerHeight: number = 315;

  /** Height of all page elements above the insol-page-box when header is collapsed.  Used to calculate height of the box,
   * so it shows fully on the screen without scrolling.  Make it ~100px to allow scrolling enough to hide the header elements.
   * Defaults to 210, the height of header on time review pages */
  @Input() collapsedHeight: number = 210;

  currentHeight$: Observable<number>;

  constructor(componentStateService: ComponentStateService) {
    const pageHeaderState = componentStateService.getComponentState<PageHeaderState>('PageHeader', 'global');
    this.currentHeight$ = pageHeaderState.stateChanged$.pipe(
      startWith(pageHeaderState.getState()),
      map((collapsedState) => (collapsedState.isCollapsed ? this.collapsedHeight : this.headerHeight))
    );
  }
}
